export enum OperationColumnsEnum {
  Operation = 'operation',
  Note = 'note',
  CostCenterNumber = 'costCenterNumber',
  CostCenterName = 'costCenterName',
}
